import { NgModule } from '@angular/core';
import { CardModule } from '@app/card/card.module';
import { ContractModule } from '@app/contract/contract.module';
import { EnergyModule } from '@app/energy/energy.module';
import { MoveWizardModule } from '@app/move-wizard/move-wizard.module';
import { PoweredBySmoovedComponent } from '@app/ots/components/powered-by-smooved/powered-by-smooved.component';
import { ContactDetailsContainer } from '@app/ots/containers/contact-details/contact-details.container';
import { ContractContainer } from '@app/ots/containers/contract-container/contract-container.container';
import { MoveDetailsContainer } from '@app/ots/containers/move-details/move-details.container';
import { OtherServicesContainer } from '@app/ots/containers/other-services/other-services.container';
import { OtsContainerContainer } from '@app/ots/containers/ots-container/ots-container.container';
import { PaymentDetailsContainer } from '@app/ots/containers/payment-details/payment-details.container';
import { SuccessContainer } from '@app/ots/containers/success/success.container';
import { SharedModule } from '@app/shared/shared.module';
import { TelecomModule } from '@app/telecom/telecom.module';
import { OtsRoutingModule } from './ots-routing.module';

@NgModule({
    declarations: [
        OtherServicesContainer,
        ContractContainer,
        MoveDetailsContainer,
        ContactDetailsContainer,
        PaymentDetailsContainer,
        PoweredBySmoovedComponent,
        OtsContainerContainer,
        SuccessContainer,
    ],
    imports: [OtsRoutingModule, ContractModule, CardModule, SharedModule, MoveWizardModule, TelecomModule, EnergyModule],
    providers: [],
})
export class OtsModule {}
